export type HrEmployeeSession = {
  token: string;
  role: "hr_employee";
  employee: {
    id: number;
    employee_code: string;
    name: string;
    email?: string | null;
  };
};

export type HrEmployerSession = {
  token: string;
  role: "hr_employer";
  employer: {
    id: number;
    email: string;
    name: string;
    role: string;
  };
};

const HR_EMPLOYEE_SESSION = "bcec_hr_employee_session";
const HR_EMPLOYER_SESSION = "bcec_hr_employer_session";

function readJson<T>(key: string): T | null {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function getHrEmployeeSession(): HrEmployeeSession | null {
  return readJson<HrEmployeeSession>(HR_EMPLOYEE_SESSION);
}

export function setHrEmployeeSession(session: HrEmployeeSession) {
  localStorage.setItem(HR_EMPLOYEE_SESSION, JSON.stringify(session));
}

export function clearHrEmployeeSession() {
  localStorage.removeItem(HR_EMPLOYEE_SESSION);
}

export function getHrEmployerSession(): HrEmployerSession | null {
  return readJson<HrEmployerSession>(HR_EMPLOYER_SESSION);
}

export function setHrEmployerSession(session: HrEmployerSession) {
  localStorage.setItem(HR_EMPLOYER_SESSION, JSON.stringify(session));
}

export function clearHrEmployerSession() {
  localStorage.removeItem(HR_EMPLOYER_SESSION);
}
